import { render, staticRenderFns } from "./WebsiteFooter.vue?vue&type=template&id=60816875&"
import script from "./WebsiteFooter.vue?vue&type=script&lang=js&"
export * from "./WebsiteFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports